import React, { useState } from 'react';
import Logo from './Logo';
import DetailPembayaran from './DetailPembayaran';

const Pembayaran = ({ onBack, activeBottomTab, setActiveBottomTab }) => {
  const [showDetailPembayaran, setShowDetailPembayaran] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  // Data summary pembayaran
  const summaryData = {
    tabunganTerkumpul: 'Rp 1.000.000',
    totalTabungan: 'Rp 3.600.000',
    sisaTabungan: 'Rp 2.600.000',
    waktuTersisa: '4 bulan, 6 hari lagi Menuju Idul Adha',
    progressPercentage: 28
  };

  // Data pembayaran
  const pembayaranData = [
    {
      id: 'BYR2509170002',
      date: '17 September 2025',
      amount: 'Rp 500.000',
      status: 'Diterima',
      bank: 'Ke Rekening BCA',
      // Data detail untuk halaman detail pembayaran
      paymentCode: 'BYR2509170002',
      customerName: 'Ir. Eni Sugiarti',
      toAccount: 'BCA',
      paymentAmount: 'Rp 500.000',
      paymentDate: '17 September 2025',
      statusDetail: 'Diterima',
      description: 'DP Tabungan Qurban Domba',
      transferData: {
        fromAccount: '4970814901',
        toAccount: '6750408956 NANANG SUGIARTO',
        amount: 'Rp 500.000,00',
        dateTime: '17/09/2025 14:44:06',
        description: 'tabungan kurban domba afri dp'
      }
    },
    {
      id: 'BYR2509250003',
      date: '25 September 2025',
      amount: 'Rp 500.000',
      status: 'Diterima',
      bank: 'Ke Rekening BNI',
      // Data detail untuk halaman detail pembayaran
      paymentCode: 'BYR2509250003',
      customerName: 'Ir. Eni Sugiarti',
      toAccount: 'BNI',
      paymentAmount: 'Rp 500.000',
      paymentDate: '25 September 2025',
      statusDetail: 'Diterima',
      description: 'DP Tabungan Qurban Domba',
      transferData: {
        fromAccount: '4970814901',
        toAccount: '6750408956 NANANG SUGIARTO',
        amount: 'Rp 500.000,00',
        dateTime: '25/09/2025 14:44:06',
        description: 'tabungan kurban domba afri dp'
      }
    }
  ];

  // Jika sedang menampilkan detail pembayaran
  if (showDetailPembayaran && selectedPayment) {
    return (
      <DetailPembayaran 
        paymentData={selectedPayment}
        onBack={() => setShowDetailPembayaran(false)}
        activeBottomTab={activeBottomTab}
        setActiveBottomTab={setActiveBottomTab}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <button 
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <div className="flex items-center space-x-2">
                <Logo size="small" showText={false} />
                <span className="font-bold text-primary text-lg">Pembayaran</span>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-24 bg-gray-50">
          {/* Tabungan Terkumpul Section */}
          <section className="px-4 pt-6">
            <div className="bg-white rounded-2xl shadow-lg p-4 mb-4">
              <div className="flex items-center space-x-3 mb-3">
                <div className="bg-secondary p-2 rounded-lg">
                  <i className="fa-solid fa-piggy-bank text-accent text-lg"></i>
                </div>
                <div>
                  <h3 className="text-gray-600 text-sm font-medium">Tabungan Terkumpul</h3>
                  <p className="text-2xl font-bold text-primary">{summaryData.tabunganTerkumpul}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <p className="text-gray-600 text-sm">Total Tabungan</p>
                  <p className="text-primary font-semibold">{summaryData.totalTabungan}</p>
                </div>
                <div>
                  <p className="text-gray-600 text-sm">Sisa Tabungan</p>
                  <p className="text-primary font-semibold">{summaryData.sisaTabungan}</p>
                </div>
              </div>
            </div>

            {/* Waktu Tersisa */}
            <div className="bg-white rounded-2xl shadow-lg p-4 mb-4">
              <h4 className="text-gray-700 font-semibold mb-2">Waktu Tersisa</h4>
              <p className="text-gray-600 text-sm">{summaryData.waktuTersisa}</p>
              
              <div className="mt-3">
                <p className="text-gray-700 font-semibold mb-2">Progres Tabungan</p>
                <div className="bg-gray-200 rounded-full h-3 overflow-hidden">
                  <div 
                    className="bg-orange-500 h-full rounded-full transition-all duration-500"
                    style={{ width: `${summaryData.progressPercentage}%` }}
                  ></div>
                </div>
                <p className="text-orange-500 font-semibold text-sm mt-1">{summaryData.progressPercentage}%</p>
              </div>
            </div>
          </section>

          {/* Data Pembayaran */}
          <section className="px-4">
            <h3 className="text-gray-700 font-semibold mb-4">Data Pembayaran</h3>
            
            <div className="space-y-4">
              {pembayaranData.map((payment, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className="p-4">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <p className="text-accent font-bold text-lg">{payment.id}</p>
                        <p className="text-gray-600 text-sm">{payment.date}</p>
                        <p className="text-gray-600 text-sm">{payment.bank}</p>
                      </div>
                      <div className="text-right">
                        <span className="bg-green-100 text-green-700 text-xs font-medium px-3 py-1 rounded-full">
                          {payment.status}
                        </span>
                        <p className="text-primary font-bold text-lg mt-2">{payment.amount}</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Action Button */}
                  <div className="px-4 pb-4">
                    <button 
                      onClick={() => {
                        setSelectedPayment(payment);
                        setShowDetailPembayaran(true);
                      }}
                      className="w-full bg-accent text-primary font-semibold py-3 px-4 rounded-xl flex items-center justify-center space-x-2 hover:bg-accent/90 transition-colors"
                    >
                      <i className="fa-solid fa-info-circle"></i>
                      <span>Detail Pembayaran</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </main>

        {/* Bottom Navigation */}
        <footer className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white pt-2">
          <div className="bg-primary mx-4 mb-4 rounded-2xl shadow-lg">
            <div className="flex justify-around items-center h-20 text-white">
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'home' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('home');
                  onBack();
                }}
              >
                <i className="fa-solid fa-house text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Beranda</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'savings' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('savings');
                  onBack();
                }}
              >
                <i className="fa-solid fa-piggy-bank text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Tabungan</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'products' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => setActiveBottomTab('products')}
              >
                <i className="fa-solid fa-box-archive text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Produk</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'investment' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('investment');
                  onBack();
                }}
              >
                <i className="fa-solid fa-arrow-trend-up text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Investasi</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'account' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('account');
                  onBack();
                }}
              >
                <i className="fa-solid fa-user-circle text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Akun</span>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Pembayaran;
